export const en = {
    // Navigation
    nav_home: 'Home',
    nav_schedule: 'Schedule',
    nav_tournaments: 'Tournaments',
    nav_series: 'All Series',
    nav_squads: 'Squads',
    nav_players: 'Players',
    nav_stats: 'Stats',
    nav_matches: 'Matches',
    nav_more: 'More',
    nav_rankings: 'Rankings',
    nav_champions: 'Champions',

    // Menu
    menu_title: 'Menu',
    menu_profile_login: 'Login to access full features',
    menu_go_premium: 'GO PREMIUM',
    menu_app_settings: 'App Settings',
    menu_match_settings: 'Match Settings',
    menu_app_theme: 'App Theme',
    menu_notifications: 'Notification Settings',
    menu_languages: 'Languages',
    menu_go_premium_active: 'Premium version coming soon',
    premium_coming_soon: 'Premium version will be released very soon!',
    menu_report_problem: 'Report a Problem',
    admin_contact_request: 'Want to become an admin? Contact us at batchcrick@gmail.com',
    menu_privacy_policy: 'Privacy Policy',
    menu_terms: 'Terms of Service',
    menu_terms_privacy: 'Terms & Privacy',
    menu_partner: 'Partner with us',
    menu_logout: 'Log Out',
    menu_select_language: 'Select Language',
    language_english: 'English',
    language_bengali: 'Bengali',

    // Theme
    theme_light: 'Light',
    theme_dark: 'Dark',

    // Status
    status_success: 'Success',
    status_error: 'Error',
    loading: 'Loading...',

    // Common
    see_all: 'See All',
    no_data: 'No data available',

    // Cricket Terms
    runs: 'Runs',
    wickets: 'Wickets',
    overs: 'Overs',
    run_rate: 'CRR',
    req_rate: 'RRR',
    extra: 'Extras',
    target: 'Target',
    toss: 'Toss',
    won_toss: 'won the toss and elected to',
    bat: 'bat',
    bowl: 'bowl',
    won_by: 'won by',
    by_wickets: 'wickets',
    by_runs: 'runs',
    match_drawn: 'Match Drawn',
    match_tied: 'Match Tied!',
    friendly_match: 'Friendly Match',
    player_of_match: 'Player of the Match',

    // Status
    live: 'Live',
    upcoming: 'Upcoming',
    completed: 'Completed',
    match_completed: 'Match Completed',
    innings_break: 'Innings Break',
    player_entering: 'Player Entering',
    waiting_super_over: 'Waiting for Super Over',
    result: 'Result',

    // Dynamic Messages
    need_runs_in_balls: 'need ${runs} runs in ${balls} balls',

    // Player Roles
    batsman: 'Batter',
    bowler: 'Bowler',
    all_rounder: 'All Rounder',
    wicket_keeper: 'Wicket Keeper',
    captain: 'Captain',
    vice_captain: 'Vice Captain',

    // Tabs & Sections
    tab_info: 'Info',
    tab_live: 'Live',
    tab_scorecard: 'Scorecard',
    tab_squads: 'Squads',
    tab_playing_xi: 'Playing XI',
    tab_graphs: 'Graphs',
    tab_commentary: 'Commentary',
    tab_summary: 'Summary',
    tab_point_table: 'Table',
    tab_mvp: 'MVP',

    // Stats Headers
    matches: 'Mat',
    innings: 'Inn',
    average: 'Avg',
    strike_rate: 'SR',
    economy: 'Econ',
    best_bowling: 'BBI',
    high_score: 'HS',
    fifties: '50s',
    hundreds: '100s',

    // Tournaments
    organizer: 'Organizer',
    season: 'Season',
    start_date: 'Start Date',
    end_date: 'End Date',
    groups: 'Groups',
    knockout: 'Knockout',
    standings: 'Standings',

    // Squads
    team_squad: 'Team Squad',
    playing_xi: 'Playing XI',
    bench: 'Bench',
    coach: 'Coach',
    manager: 'Manager',

    // Filters & Messages
    filter_all: 'All',
    filter_men: 'Men',
    filter_t20: 'T20',
    filter_odi: 'ODI',
    filter_international: 'International',
    no_series_found: 'No Series Found',
    check_back_later: 'Check back later for cricket series updates.',

    // Players Page
    search_players: 'Search elite players...',
    no_players_found: 'No Players Found',
    adjust_filters: 'Adjust your search or category filters',

    // Squads Page
    all_batches: 'All Batches',
    no_squads_found: 'No squads found',
    view_squad: 'View Squad',

    // Auth Errors
    auth_error_wrong_password: 'Incorrect password! Please try again.',
    auth_error_user_not_found: 'No account found with this email.',
    auth_error_invalid_email: 'Invalid email address.',
    auth_error_too_many_attempts: 'Too many attempts. Account temporarily locked.',
    auth_error_generic: 'Authentication failed. Please check your credentials.',
    auth_error_email_in_use: 'This email is already registered.',
    auth_error_weak_password: 'Password should be at least 6 characters.',
    auth_error_no_permission: 'You do not have permission to access this application.',
    auth_error_unverified_email: 'You must verify your email first before logging in. Please check your inbox!',
    auth_success_password_reset: 'Password reset email sent!',
    auth_success_password_updated: 'Password updated successfully!',
    auth_email_reset_sent: 'Password reset email sent!',
    auth_account_created: 'Account successfully created!',
    auth_locked_out: 'Too many wrong attempts! Try again after {minutes} minutes.',
    auth_attempts_remaining: '{count} attempts remaining.',
    auth_wait_seconds: 'Wait {seconds} seconds...',
};
